<template>
	<view class="box">
		<!-- 轮播图 -->
		<view class="store_banner">
			<uni-swiper-dot :info="info" :current="current" field="content" mode="round">
				<swiper class="swiper-box" @change="change">
					<swiper-item v-for="(item, index) in 3" :key="index">
						<view class="swiper-item">
							<image src="@/static/images/Maskgroup@2x.png" mode="aspectFill"></image>
						</view>
					</swiper-item>
				</swiper>
			</uni-swiper-dot>
			<view class="store_banner_mode">
				<text>{{current}}/{{info.length}}</text>
			</view>
		</view>
		<view class="box_info">
			<view class="box_info_top">
				<view class="box_info_top_left">
					<text>¥</text>
					<text>179</text>
					<text>.98</text>
				</view>
				<text>已售619份</text>
			</view>
			<view class="box_info_title">
				清澄白河马克杯-节日版定制
			</view>
		</view>
		<view class="box_ensure">
			<view class="box_ensure_item">
				<view class="label">保障</view>
				<view class="value">假一赔四 · 坏损包退 · 极速退款</view>
			</view>
			<view class="box_ensure_item">
				<view class="label">保障</view>
				<view class="value">假一赔四 · 坏损包退 · 极速退款</view>
			</view>
		</view>
		<view class="box_notfind">
			该商品暂无评价
		</view>
		<view class="box_appraise">
			<view class="head">
				<text>商品评价</text>
				<view class="head_right" @click="toDesc">
					<text>查看全部</text>
					<uni-icons type="forward" size="18" color="#999999"></uni-icons>
				</view>
			</view>
			<view class="list">
				<view class="list_item">
					<view class="list_item_top">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<text>木**王</text>
					</view>
					<view class="list_item_fen">
						<uni-rate size="18" :value="3" color="#bbb" active-color="#D20A0A" />
						<view class="list_item_fen_x"></view>
						<text>白色</text>
					</view>
					<view class="desc">
						好好看，质量也棒棒哒！
					</view>
				</view>
				<view class="list_item">
					<view class="list_item_top">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<text>木**王</text>
					</view>
					<view class="list_item_fen">
						<uni-rate size="18" :value="3" color="#bbb" active-color="#D20A0A" />
						<view class="list_item_fen_x"></view>
						<text>白色</text>
					</view>
					<view class="desc">
						好好看，质量也棒棒哒！
					</view>
				</view>
			</view>
		</view>
		<view class="box_recommend">
			<view class="label">店铺推荐</view>
			<view class="box_recommend_list">
				<view class="box_recommend_list_item" v-for="(item, index) in 4" :key="index">
					<image src="@/static/uni.png" mode="widthFix"></image>
					<view class="box_recommend_list_item_title">
						清澄白河马克杯-节 日版定制
					</view>
					<view class="box_recommend_list_item_price">
						<text>¥</text>
						<text>179</text>
					</view>
				</view>
				<view class="box_recommend_list_itemz"></view>
				<view class="box_recommend_list_itemz"></view>
			</view>
		</view>
		<view class="box_desc">
			<view class="label">商品详情</view>
			<view class="box_desc_content">
				富文本
			</view>
		</view>
		<view class="box_zw"></view>
		<view class="shop_operate">
			<view class="shop_operate_list">
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_cart@2x.png" mode="widthFix"></image>
					<text>购物车</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_kefu@2x.png" mode="widthFix"></image>
					<text>客服</text>
				</view>
				<view class="shop_operate_list_item" @click="share">
					<image src="@/static/icon/ic_fenxiang@2x.png" mode="widthFix"></image>
					<text>分享</text>
				</view>
			</view>
			<view class="shop_operate_ipt">
				<view class="shop_operate_ipt_left" @click="addShoppingCar('加入购物车')">
					加入购物车
				</view>
				<view class="shop_operate_ipt_right" @click="addShoppingCar('下一步')">
					立即购买
				</view>
			</view>
		</view>
		<!-- 加入购物车 -->
		<uni-popup ref="popup" background-color="#fff">
			<view class="popup">
				<view class="popup_head">
					<view class="popup_head_left">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<view class="popup_head_left_price">
							<text>¥</text>
							<text>179</text>
							<text>.98</text>
						</view>
					</view>
					<uni-icons type="closeempty" size="20" color="#999999" @click="closeCar"></uni-icons>
				</view>
				<view class="popup_x"></view>
				<view class="popup_list">
					<view class="popup_list_item">
						<view class="label">颜色</view>
						<view class="child">
							<view class="child_item active">白色</view>
							<view class="child_item">白色</view>
						</view>
					</view>
					<view class="popup_list_item1">
						<view class="label">数量</view>
						<uni-number-box @change="changeValue" />
					</view>
				</view>
				<view class="popup_submit">
					<view class="popup_submit_btn" @click="toOrder">{{name}}</view>
				</view>
			</view>
		</uni-popup>
		<view class="share_img" v-if="isOpen">
			<image src="@/static/images/qiandao1bg@2x.png" mode="widthFix"></image>
		</view>
		<!-- 分享 -->
		<uni-popup ref="popup1" background-color="#fff">
			<view class="share">
				<view class="share_list">
					<view class="share_list_item">
						<image src="@/static/icon/share_ic_wechat@2x.png" mode="widthFix"></image>
						<text>微信好友</text>
					</view>
					<view class="share_list_item">
						<image src="@/static/icon/share_ic_baocun@2x.png" mode="widthFix"></image>
						<text>保存到相册</text>
					</view>
				</view>
				<view class="share_submit" @click="close">取消</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				isOpen: false,
				current: 1,
				info: [{
					content: '内容 A'
				}, {
					content: '内容 B'
				}, {
					content: '内容 C'
				}],
				name: ''
			}
		},
		methods: {
			change(e) {
				this.current = e.detail.current + 1;
			},
			toDesc() {
				uni.navigateTo({
					url: '/pages/allEvaluations/index'
				});
			},
			toOrder() {
				uni.navigateTo({
					url: '/pages/mallOrderConfirmation/index'
				});
			},
			addShoppingCar(name) {
				this.name = name
				this.$refs.popup.open('bottom')
			},
			closeCar() {
				this.$refs.popup.close()
			},
			share() {
				this.isOpen = true
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.isOpen = false
				this.$refs.popup1.close()
			},
			changeValue(value) {
				console.log('返回数值：', value);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.store_banner /deep/ {
			width: 100%;
			height: 748rpx;
			position: relative;
			.store_banner_mode {
				position: absolute;
				bottom: 42rpx;
				right: 32rpx;
				width: 64rpx;
				height: 36rpx;
				background: rgba(0,0,0,0.4);
				border-radius: 18rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
			.uni-swiper__warp {
				width: 100%;
				height: 100%;
			}
			.uni-swiper__dots-box {
				display: none;
			}
			.swiper-box {
				width: 100%;
				height: 100%;
				.swiper-item {
					width: 100%;
					height: 100%;
					image {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
		.box_info {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			.box_info_top {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
				}
				.box_info_top_left {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
							margin-top: 11rpx;
						}
						&:nth-child(2) {
							font-size: 40rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
						}
						&:nth-child(3) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
							margin-top: 11rpx;
						}
					}
				}
			}
			.box_info_title {
				font-size: 36rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-top: 16rpx;
			}
		}
		.box_ensure {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			margin-top: 16rpx;
			.box_ensure_item {
				display: flex;
				align-items: center;
				margin-bottom: 20rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				.label {
					flex-shrink: 0;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					margin-right: 15rpx;
				}
				.value {
					flex: 1;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
				}
			}
		}
		.box_appraise {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			margin-top: 16rpx;
			.head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
				.head_right {
					display: flex;
					align-items: center;
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						margin-right: 8rpx;
					}
				}
			}
			.list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 24rpx;
				.list_item {
					display: flex;
					flex-direction: column;
					padding-bottom: 24rpx;
					margin-top: 24rpx;
					border-bottom: 2rpx solid #F4F5F4;
					&:first-child {
						margin-top: 0 !important;
					}
					&:last-child {
						padding-bottom: 0 !important;
						border: none !important;
					}
					.list_item_top {
						display: flex;
						align-items: center;
						image {
							width: 44rpx;
							height: 44rpx;
							border-radius: 50%;
							margin-right: 12rpx;
						}
						text {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}
					.list_item_fen {
						display: flex;
						align-items: center;
						margin-top: 14rpx;
						.list_item_fen_x {
							width: 0rpx;
							height: 12rpx;
							margin: 0 12rpx;
							border: 1rpx solid #999999;
						}
						text {
							font-size: 20rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
					}
					.desc {
						margin-top: 20rpx;
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
			}
		}
		.box_recommend {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			margin-top: 16rpx;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 24rpx;
			}
			.box_recommend_list {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				.box_recommend_list_itemz {
					width: 212rpx;
					height: 0;
				}
				.box_recommend_list_item {
					width: 212rpx;
					display: flex;
					flex-direction: column;
					margin-bottom: 20rpx;
					&:nth-child(n+4) {
						margin-bottom: 0 !important;
					}
					image {
						width: 212rpx;
						height: 212rpx;
						background: #F8F8F8;
						border-radius: 8rpx;
					}
					.box_recommend_list_item_title {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						margin-top: 22rpx;
						margin-bottom: 16rpx;
					}
					.box_recommend_list_item_price {
						display: flex;
						align-items: center;
						text {
							&:first-child {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
								margin-top: 11rpx;
							}
							&:last-child {
								font-size: 32rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
							}
						}
					}
				}
			}
		}
		.box_desc {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			margin-top: 16rpx;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 24rpx;
			}
			.box_desc_content {
				margin-top: 30rpx;
			}
		}
		.box_zw {
			width: 100%;
			height: calc(112rpx + env(safe-area-inset-bottom));
		}
		.shop_operate {
			width: 100%;
			padding: 16rpx 32rpx calc(env(safe-area-inset-bottom) + 16rpx) 32rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			position: fixed;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.shop_operate_ipt {
				width: 440rpx;
				height: 72rpx;
				border-radius: 36rpx;
				overflow: hidden;
				background-color: #D20A0A;
				overflow: hidden;
				display: flex;
				align-items: center;
				.shop_operate_ipt_left {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #D95A5A;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
				.shop_operate_ipt_right {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #D20A0A;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
			}
			.shop_operate_list {
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-right: 48rpx;
				.shop_operate_list_item {
					display: flex;
					align-items: center;
					flex-direction: column;
					image {
						width: 30rpx !important;
						height: 30rpx !important;
						margin-bottom: 8rpx;
					}
					text {
						font-size: 16rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
		.box_notfind {
			width: 100%;
			margin-top: 16rpx;
			padding: 28rpx 32rpx;
			background-color: #FFFFFF;
			font-size: 32rpx;
			box-sizing: border-box;
			font-family: PingFang SC-Semibold, PingFang SC;
			font-weight: 600;
			color: #333333;
		}
		.popup {
			width: 100%;
			padding: 44rpx 32rpx 0 32rpx;
			background-color: #FFFFFF;
			box-sizing: border-box;
			.popup_head {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				.popup_head_left {
					display: flex;
					align-items: center;
					image {
						width: 128rpx;
						height: 128rpx;
						border-radius: 10rpx;
						margin-right: 16rpx;
					}
					.popup_head_left_price {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
								margin-top: 11rpx;
							}
							&:nth-child(2) {
								font-size: 40rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
							}
							&:nth-child(3) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
								margin-top: 11rpx;
							}
						}
					}
				}
			}
			.popup_x {
				width: 100%;
				height: 2rpx;
				background-color: #F4F5F4;
				margin: 48rpx 0;
			}
			.popup_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				.popup_list_item1 /deep/ {
					display: flex;
					align-items: center;
					justify-content: space-between;
					.label {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.uni-numbox-btns {
						background-color: rgba(0,0,0,0) !important;
					}
					.uni-numbox__value {
						color: #333333 !important;
					}
				}
				.popup_list_item {
					display: flex;
					flex-direction: column;
					margin-bottom: 62rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					.label {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.child {
						margin-top: 24rpx;
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						.active {
							background: rgba(210,10,10,0.08) !important;
							border: 2rpx solid #D20A0A !important;
							color: #D20A0A !important;
						}
						.child_item {
							display: flex;
							align-items: center;
							justify-content: center;
							padding: 24rpx 48rpx;
							box-sizing: border-box;
							background: #F5F5F5;
							border-radius: 16rpx;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin-right: 26rpx;
							&:last-child {
								margin-right: 0 !important;
							}
						}
					}
				}
			}
			.popup_submit {
				width: 100%;
				padding: 20rpx 24rpx 20rpx 24rpx;
				box-sizing: border-box;
				border: 2rpx solid #F4F5F4;
				margin-top: 126rpx;
				.popup_submit_btn {
					width: 100%;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
			}
		}
		.share_img {
			width: 100%;
			height: 622rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			position: fixed;
			top: 104rpx;
			z-index: 999;
			overflow: hidden;
			image {
				width: 596rpx;
				height: 100%;
				border-radius: 10rpx;
			}
		}
		.share {
			width: 100%;
			padding: 48rpx 32rpx 0 32rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			.share_list {
				display: flex;
				align-items: center;
				.share_list_item {
					margin-right: 64rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					image {
						width: 92rpx;
						height: 92rpx;
						margin-bottom: 22rpx;
					}
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #666666;
					}
				}
			}
			.share_submit {
				margin-top: 40rpx;
				padding: 32rpx 0 32rpx 0;
				border: 2rpx solid #F4F5F4;
				width: 100%;
				text-align: center;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
			}
		}
	}
</style>